module.exports = __webpack_public_path__ + "img/dxch.27bef51f.jpg";